module.exports = __webpack_public_path__ + "static/experiments-84c81e3beb357fcb5a016078fea5bc4b.gif";